import { SELECT_YOUTUBE} from '../constants/actionTypes'


export const selectYoutube = selectedYoutube => ({
    type: SELECT_YOUTUBE,
    selectedYoutube,
})